import { ArrowDownTrayIcon, DocumentTextIcon } from '@heroicons/react/24/outline'
import type { Attachment } from '../../client'
import AttachmentPreview from '../home/AttachmentPreview'

type Props = {
  items: Attachment[]
  align?: 'start' | 'end'
  onPreview: (attachment: Attachment) => void
}

function FileDownload({ attachment }: { attachment: Attachment }) {
  return (
    <a
      href={attachment.url}
      download={attachment.original_filename ?? true}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2 rounded-lg border border-stone-200 bg-stone-100 px-3 py-2 text-xs text-stone-700 hover:bg-stone-200"
    >
      <DocumentTextIcon className="size-4 shrink-0 text-stone-500" />
      <span className="truncate">{attachment.original_filename ?? 'Download file'}</span>
      <ArrowDownTrayIcon className="size-4 shrink-0 text-stone-500" />
    </a>
  )
}

export default function Attachments({ items, align = 'start', onPreview }: Props) {
  if (items.length === 0) return null

  const files = items.filter((attachment) => attachment.kind === 'file')
  const media = items.filter((attachment) => attachment.kind !== 'file')

  return (
    <div
      className={`flex flex-wrap gap-1.5 ${align === 'end' ? 'justify-end' : ''}`}
    >
      {media.map((attachment) => (
        <button
          key={attachment.asset_id}
          type="button"
          onClick={() => onPreview(attachment)}
          className="block size-24 shrink-0 overflow-hidden rounded-lg border border-stone-200"
        >
          <AttachmentPreview attachment={attachment} />
        </button>
      ))}
      {files.map((attachment) => (
        <FileDownload key={attachment.asset_id} attachment={attachment} />
      ))}
    </div>
  )
}
